import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { LoadMoreButton } from '@/components/RunsTable/LoadMoreButton';
import { useRepoCommitTags } from '@/hooks/useSwr';
import { CommitWithLookupsSchema } from '@/types/schema';

import { CommitItem } from './CommitItem';

export const CommitsList = (props: {
  currentCommit: string;
  commits: Array<CommitWithLookupsSchema>;
  hasMore: boolean;
  isNextPageLoading: boolean;
  setSize: React.Dispatch<React.SetStateAction<number>>;
  inHub: boolean;
  setShowDiff: (showDiff: boolean) => void;
}) => {
  const { owner, repo } = useParams();
  const { data: tags } = useRepoCommitTags(owner, repo);
  const activeCommitRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (activeCommitRef.current) {
      activeCommitRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [props.currentCommit]);

  return (
    <div className="flex h-full w-[500px] flex-col overflow-y-auto border-r border-secondary text-sm">
      {props.commits.map((commit, index) => {
        return (
          <div
            ref={
              commit.commit_hash.startsWith(props.currentCommit)
                ? activeCommitRef
                : undefined
            }
            key={commit.commit_hash}
          >
            <CommitItem
              active={commit.commit_hash.startsWith(props.currentCommit)}
              commit={commit}
              inHub={props.inHub}
              tags={tags ?? []}
              owner={owner}
              repo={repo!}
              setShowDiff={props.setShowDiff}
              isFirstCommit={index === props.commits.length - 1}
            />
          </div>
        );
      })}
      {props.hasMore && (
        <div className="flex grow flex-col items-center">
          <LoadMoreButton
            isInitialLoad
            isLoading={props.isNextPageLoading}
            onClick={() => props.setSize((size) => size + 1)}
          />
        </div>
      )}
    </div>
  );
};
